<cc-top-bar [title]="title | translate">
  <a href="#" class="no-hover show-always">
  </a>
</cc-top-bar>
<div class="content-container">
  <div class="channels-button-wrapper">
    <button class="channels-button confirm"
            id="confirm"
            (click)="back()">{{'BACK' | translate}}
    </button>
  </div>

  <router-outlet></router-outlet>
</div>

